import { render, staticRenderFns } from "./PanelView.vue?vue&type=template&id=2431c55c&scoped=true"
import script from "./PanelView.vue?vue&type=script&lang=js"
export * from "./PanelView.vue?vue&type=script&lang=js"
import style0 from "./PanelView.vue?vue&type=style&index=0&id=2431c55c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2431c55c",
  null
  
)

export default component.exports